import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { IComparator } from "../models/comparator.models";
import { environment } from "src/environments/environment";
import { IExecuteSeccess, IMatchingColumn, IResponseMatching } from "../../imports/models/imports.models";

@Injectable({
    providedIn: 'root',
  })
  export class ComparatorService {
  
    constructor(private http: HttpClient) { }

    public listComparators(): Observable<APIResponse<IComparator>> {
      return this.http.get<APIResponse<IComparator>>(
        environment.BASE_URL_API + 'comparators/imports'
      );
    }

    public importComaparators(file: any): Observable<APIResponse<IResponseMatching>> {
      return this.http.post<APIResponse<IResponseMatching>>(
        environment.BASE_URL_API + 'comparators/imports/set-file',
        file
      );
    }

    public reImportComaparators(id: number, file: any): Observable<APIResponse<IResponseMatching>> {
      return this.http.post<APIResponse<IResponseMatching>>(
        environment.BASE_URL_API + 'comparators/imports/' + id + '/reset-file',
        file
      );
    }

    public matchingComparatorsColumns(id: number, matchingColumns: IMatchingColumn): Observable<APIResponse<IExecuteSeccess>> {
      return this.http.post<APIResponse<IExecuteSeccess>>(
        environment.BASE_URL_API + 'comparators/imports/' + id + '/execute',
        matchingColumns
      );
    }

    public detailsComparator(id: number): Observable<APIResponse<IExecuteSeccess>> {
      return this.http.get<APIResponse<IExecuteSeccess>>(
        environment.BASE_URL_API + 'comparators/imports/' + id
      );
    }

    public getFileComparator(id: number): Observable<{data: [], object: {file: string}}> {
      return this.http.get<{data: [], object: {file: string}}>(
        environment.BASE_URL_API + 'comparators/imports/' + id + '/download-file'
      );
    }

}